import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from '../../contexts/TranslationContext';
import '../../styles/legal.scss';

const CookiePolicy: React.FC = () => {
  const { t } = useTranslation();
  const lc = t.legal.cookies;

  return (
    <div className="legal-page">
      <Helmet>
        <title>Cookie Policy | PhilipSnat</title>
        <meta name="description" content="Read the PhilipSnat Cookie Policy to understand how we use cookies and tracking technologies." />
        <link rel="canonical" href="https://philipsnat.com/cookie-policy" />
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="legal-page__container">
        <div className="legal-page__header">
          <h1 className="legal-page__title">{lc.title}</h1>
          <p className="legal-page__updated">{t.legal.lastUpdated.replace('{date}', 'May 4, 2026')}</p>
        </div>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lc.s1Title}</h2>
          <p className="legal-page__text">{lc.s1Text}</p>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lc.s2Title}</h2>
          <p className="legal-page__text">{lc.s2Intro}</p>
          <div className="legal-page__cookie-table">
            <div className="legal-page__cookie-row legal-page__cookie-row--header">
              <span>{lc.tableCookie}</span>
              <span>{lc.tablePurpose}</span>
              <span>{lc.tableDuration}</span>
            </div>
            <div className="legal-page__cookie-row">
              <span><code>auth_token</code></span>
              <span>{lc.authPurpose}</span>
              <span>{lc.authDuration}</span>
            </div>
            <div className="legal-page__cookie-row">
              <span><code>email_verification_token</code></span>
              <span>{lc.emailVerifyPurpose}</span>
              <span>{lc.emailVerifyDuration}</span>
            </div>
            <div className="legal-page__cookie-row">
              <span><code>app_language</code></span>
              <span>{lc.languagePurpose}</span>
              <span>{lc.languageDuration}</span>
            </div>
          </div>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lc.s3Title}</h2>
          <div className="legal-page__highlight">
            <p className="legal-page__text">{lc.s3Text}</p>
          </div>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lc.s4Title}</h2>
          <p className="legal-page__text">{lc.s4Intro}</p>
          <ul className="legal-page__list">
            <li>{lc.s4Chrome}</li>
            <li>{lc.s4Firefox}</li>
            <li>{lc.s4Safari}</li>
            <li>{lc.s4Edge}</li>
          </ul>
        </section>

        <section className="legal-page__section">
          <h2 className="legal-page__section-title">{lc.s5Title}</h2>
          <p className="legal-page__text">{lc.s5Text}</p>
        </section>
      </div>
    </div>
  );
};

export default CookiePolicy;
